module.exports = __webpack_public_path__ + "img/ph.dbe089bb.svg";